<template>
    <div class="img-user-stage">
        <img v-if="stage == 0" src="../assets/img/member_level_0.png" :class="className">
        <img v-if="stage == 1" src="../assets/img/member_level_1.png" :class="className">
        <img v-else-if="stage == 2" src="../assets/img/member_level_2.png" :class="className">
        <img v-else-if="stage == 3" src="../assets/img/member_level_3.png" :class="className">
        <img v-else-if="stage == 4" src="../assets/img/member_level_4.png" :class="className">
        <!-- <img v-if="stage == 5" src="../assets/img/member_level_5.png" :class="className"> -->
    </div>
</template>

<script>
    export default {
        props: ['stage']
    }
</script>
